import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { BasketInfo } from 'ish-core/models/basket-info/basket-info.model';

/**
 * Displays basket info messages, e.g. if a basket operation has only partly been executed
 *
 * @example
 * <ish-basket-info></ish-basket-info>
 */
@Component({
  selector: 'ish-basket-info',
  templateUrl: './basket-info.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [AsyncPipe],
})
export class BasketInfoComponent implements OnInit {
  private checkoutFacade = inject(CheckoutFacade);

  infoMessages$: Observable<BasketInfo[]>;

  ngOnInit() {
    this.infoMessages$ = this.checkoutFacade.basketInfo$.pipe(
      map(results =>
        results?.map(info => ({
          ...info,
          causes: info?.causes?.filter(
            cause => !cause.parameters || (cause.parameters && !cause.parameters.lineItemId)
          ),
        }))
      )
    );
  }
}
